import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Krets extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleKrets = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var krets = this.props.krets
        var kretstype = krets.kretstype ? krets.kretstype.substr(krets.kretstype.indexOf('-')+1, krets.kretstype.length) : "";

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleKrets}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{kretstype} - {krets.kretsnavn}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kretsnummer')}</div>
                            <div className="value">{krets.kretsnummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kretsnavn')}</div>
                            <div className="value">{krets.kretsnavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kretstype')}</div>
                            <div className="value">{krets.kretstype}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bispedomme')}</div>
                            <div className="value">{krets.bispedomme}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('prosti')}</div>
                            <div className="value">{krets.prosti}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('prestegjeld')}</div>
                            <div className="value">{krets.prestegjeld}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('sogn')}</div>
                            <div className="value">{krets.sogn}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Krets)